import { Component, OnInit, Inject,ViewChild,ElementRef } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LabService } from 'src/app/_service/lab.service';

import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';

import html2canvas from 'html2canvas';
// declare let html2canvas: any;
declare var $: any;

@Component({
  selector: 'app-lab-test-modal',
  templateUrl: './lab-test-modal.component.html',
  styleUrls: ['./lab-test-modal.component.css']
})
export class LabTestModalComponent implements OnInit {

  @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;

  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  placements = ['left'];
  cancelClicked = false;

    LabLeadForm: FormGroup;loading:boolean=false;submitted:boolean=false;dataLoaded:boolean=false;s3url='';bds=[];hospitals=[];bds_copy=[];hospitals_copy=[];myrole:string='';invalidName:boolean=false;dialogData:any;CMAccess:any;UserId:any;labTestSubcategory =[];labTestSubcategory_copy =[];test_subcategory:boolean=true;
    testCategory=[];testCategory_copy=[];cities = []; cities_copy = [];circles=[];circles_copy=[];leadallStatus=[];leadStatus_copy=[];todayDate:Date = new Date();report_generated_date:any='';sample_collection_date:any='';balanceAmount:any='';doc_type:string='';uploading:boolean=false;test_id:any;fileDeleting:boolean = false;allUploads=[];fileExits:boolean=false;
    booking_amount=0;due_amount=0;labs=[];labs_copy=[];treatments=[];treatments_copy=[];

    constructor(public dialogRef: MatDialogRef<LabTestModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private dialog:MatDialog,
    private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private labapi: LabService,private formBuilder: FormBuilder)
    {
       
        this.dialogData=data;
        // console.log("dialogData",this.dialogData);
        this.LabLeadForm = this.formBuilder.group({
            'patient_name' : [null, Validators.required],
            'mobile' : [null, Validators.required],
            'patient_age' : [null],
            'gender' : [null],
            'test_in':[null],
            'hospital_id' : [null],
            'lab_id' : [null],
            'city_id' : [null],
            'circle_id' : [null],
            'lab_test_category' : [null],
            'lab_test_subcategory' : [null],
            'user_id' : [null],
            'status' : [null],
            'collection_type' : [null],
            'address' : [null],
            'description' : [null],
            'booking_amt' : [null],
            'due_amt' : [null],
            'balance' : [null],
            'sample_collection_date' : [null],
            'report_generated_date' : [null],
            'treatment_id' : [null],
            'payment_mode' : [null],
            'revenue' : [null]
        });
    }


    ngOnInit(): void
    {
        this.getbds();
        this.getcitiesList();
        this.getcircle();
        this.getleadStatus();
        this.getLabTestCategory();
        this.getLabTestSubcategory();
        this.getHospital();
        this.getLabs();
        this.getLabLeadDetails();
        this.getTreatment();
        this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.CMAccess = localStorage.getItem('CMAccess');
        this.UserId = localStorage.getItem('loginuserId');
        this.s3url = localStorage.getItem('s3url');

    
    }

    setSearchValue(type){
        if(type=='lead_owner'){
            $("#ownerSearch").val('');
            $("#ownerSearch").focus();
            this.bds= this.bds_copy;
        }else if(type=='testCategory'){
            $("#testCategorySearch").val('');
            $("#testCategorySearch").focus();
            this.testCategory= this.testCategory_copy;
        }else if(type=='testSubcategory'){
            $("#testSubcategorySearch").val('');
            $("#testSubcategorySearch").focus();
            this.labTestSubcategory= this.labTestSubcategory_copy;
        }else if(type=='hospital'){
            $("#hospitalSearch").val('');
            $("#hospitalSearch").focus();
            this.hospitals= this.hospitals_copy;
        }else if(type=='labs'){
            $("#labsSearch").val('');
            $("#labsSearch").focus();
            this.labs= this.labs_copy;
        }else if(type=='circle'){
            $("#circleSearch").val('');
            $("#circleSearch").focus();
            this.circles= this.circles_copy;
        }else if(type=='city'){
            $("#citySearch").val('');
            $("#citySearch").focus();
            this.cities= this.cities_copy;
        }else if(type=='status'){
            $("#statusSearch").val('');
            $("#statusSearch").focus();
            this.leadallStatus= this.leadStatus_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if(type == 'lead_owner'){
             this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'hospital'){
            this.hospitals = this.sharedapi.searchData(searchtText, this.hospitals_copy, "name");
        }else if(type == 'labs'){
            this.labs = this.sharedapi.searchData(searchtText, this.labs_copy, "name");
        }else if(type == 'testCategory'){
            this.testCategory = this.sharedapi.searchData(searchtText, this.testCategory_copy, "name");
        }else if(type == 'testSubcategory'){
            this.labTestSubcategory = this.sharedapi.searchData(searchtText, this.labTestSubcategory_copy, "name");
        }else if(type == 'circle'){
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }else if(type == 'city'){
            this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
        }else if(type == 'status'){
            this.leadallStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
        }else  if (type == 'treatment') {
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }

   
    get f() { return this.LabLeadForm.controls; }

    
    CloseModal(): void {
        this.dialogRef.close();
    }

    async getbds()
    {
        await this.labapi.getLabBds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcitiesList() {
      await this.leadapi.getcities().subscribe((data: any) => {
          if (data.status) {
              this.cities = data.data;
              this.cities_copy = this.cities;
          } else {
              this.cities = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
      await this.leadapi.getcircles().subscribe((data:any) => {
          if(data.status)
          {
              this.circles = data.data;
              this.circles_copy = this.circles;
          }else{
              this.circles = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
    }

  async getleadStatus()
  {
      await this.labapi.getLabLeadStatus().subscribe((data:any) => {
          if(data.status)
          {
              this.leadallStatus = data.data;
              this.leadStatus_copy = this.leadallStatus;
          }else{
              this.leadallStatus = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }


    async getLabTestCategory()
  {
      await this.labapi.getLabTestCategory().subscribe((data:any) => {
          if(data.status)
          {
              this.testCategory = data.data;
              this.testCategory_copy = this.testCategory;
          }else{
              this.testCategory = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getLabTestSubcategory()
  {
      await this.labapi.getLabTestSubcategory().subscribe((data:any) => {
          if(data.status)
          {
              this.labTestSubcategory = data.data;
              this.labTestSubcategory_copy = this.labTestSubcategory;
          }else{
              this.labTestSubcategory = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

    async getHospital()
    {
        this.leadapi.gethospitals().subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getLabs()
    {
        this.leadapi.getlabs().subscribe((data:any) => {
            if(data.status)
            {
                this.labs = data.data;
                this.labs_copy= this.labs;
            }else{
                this.labs = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getLabTestCategorySubcategory(lab_test_id)
    {
        let qString = 'lab_test_id='+lab_test_id;
        await this.labapi.getLabTestCategorySubcategory(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.labTestSubcategory = data.data;
                this.labTestSubcategory_copy = this.labTestSubcategory;
                this.test_subcategory=false;
            }else{
                this.labTestSubcategory = [];
                this.test_subcategory=false;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });

    }


    async updateLead()
    {
        this.submitted = true;
        this.loading = true;
       
        if (this.LabLeadForm.invalid) {
            this.loading = false;
            return;
        }
        if(this.LabLeadForm.controls['patient_name'].value.trim()=='NA' || this.LabLeadForm.controls['patient_name'].value.trim()=='N/A'){
            this.loading = false;
            this.invalidName= true;
            return;
        }else{
            this.invalidName= false;
        }
    
        let data =this.dialogData;
        await this.labapi.updateLabLead(data,this.LabLeadForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast(data.msg);
                this.getLabLeadDetails();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    getLabLeadDetails()
    {
       let data =this.dialogData;
        this.dataLoaded = false;
        this.labapi.getLabLeadDetails(data).subscribe((data:any) => {
            this.dataLoaded = true;
            if(data.status)
            {
                if(data.data)
                {
                    this.getLabTestCategorySubcategory(data.data.lab_test_category_id);
                    if(data.data.report_generated_date)
                    {
                        this.report_generated_date = new Date(data.data.report_generated_date*1000);
                    }
                    if(data.data.lab_test_id)
                    {
                        this.test_id = data.data.lab_test_id;
                    }
                    this.allUploads = data.uploads;
                    this.fileExits = this.allUploads.some(function(el){ return el.upload_type === 1});
                    this.LabLeadForm.controls['patient_name'].setValue(data.data.lead_name);
                    this.LabLeadForm.controls['mobile'].setValue(data.data.mobile);
                    this.LabLeadForm.controls['patient_age'].setValue(data.data.patient_age);
                    this.LabLeadForm.controls['gender'].setValue(data.data.gender);
                    this.LabLeadForm.controls['test_in'].setValue(data.data.test_in);
                    this.LabLeadForm.controls['lab_id'].setValue(data.data.lab_id);
                    this.LabLeadForm.controls['hospital_id'].setValue(data.data.hospital_id);
                    this.LabLeadForm.controls['city_id'].setValue(data.data.city_id);
                    this.LabLeadForm.controls['circle_id'].setValue(data.data.circle_id);
                    this.LabLeadForm.controls['lab_test_category'].setValue(data.data.lab_test_category_id);
                    this.LabLeadForm.controls['lab_test_subcategory'].setValue(data.data.lab_test_id);
                    this.LabLeadForm.controls['user_id'].setValue(data.data.user_id);
                    this.LabLeadForm.controls['status'].setValue(data.data.lead_status);
                    this.LabLeadForm.controls['treatment_id'].setValue(data.data.treatment_id);
                    this.LabLeadForm.controls['payment_mode'].setValue(data.data.payment_mode);
                    this.LabLeadForm.controls['collection_type'].setValue(data.data.collection_type);
                    this.LabLeadForm.controls['address'].setValue(data.data.patient_address);
                    this.LabLeadForm.controls['description'].setValue(data.data.description);
                    this.LabLeadForm.controls['sample_collection_date'].setValue(data.data.sample_collection_date);
                    this.LabLeadForm.controls['report_generated_date'].setValue(this.report_generated_date);
                    this.LabLeadForm.controls['booking_amt'].setValue(data.data.booking_amount);
                    this.LabLeadForm.controls['due_amt'].setValue(data.data.due_amount);
                    this.LabLeadForm.controls['balance'].setValue(data.data.balance);
                    this.LabLeadForm.controls['revenue'].setValue(data.data.revenue);
                    
                }
            }else{
                if(data.error_type!='no')
                this.sharedapi.presentToast('Error Occured');
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

    async selectFile(event)
    {
        if(this.doc_type!=undefined)
        {
            this.uploading = true;
            let file = event.target.files.item(0);
            const formData = new FormData();
            formData.append('test_id',this.test_id)
            formData.append('upload_type',this.doc_type)
            formData.append('file', file);
            let data =this.dialogData;
            await this.labapi.uploadLabFile(data,formData)
            .subscribe((data:any) => {
                this.uploading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('File uploaded Successful');
                    this.getLabLeadDetails();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
              }, error =>
                {
                    this.uploading = false;
                    this.sharedapi.checkError(error);
                });
        }else{
            this.sharedapi.presentToast('Please select Document Type');
        }
    }


    removeFile(fileId)
    {
        this.fileDeleting = true;
        this.labapi.deleteLabTestFiles(fileId).subscribe((data:any) => {
            this.fileDeleting = false;
            if(data.status)
            {
                this.getLabLeadDetails();
            }else{
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    getBalance()
    {
        this.booking_amount = this.LabLeadForm.get('booking_amt').value;
        this.due_amount = this.LabLeadForm.get('due_amt').value;
        let balance_amt = this.booking_amount - this.due_amount;
        this.LabLeadForm.controls['balance'].setValue(balance_amt);
    }
     
}
